export default {
      id: "day-period-morning-usage",
      viewBox: "0 0 40 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#day-period-morning",
      toString: function () {
        return this.url;
      }
    }